import Authenticator from './Authenticator';

export default Authenticator;
